<template>
  <section class="row">
    <div class="col-12 col-md-9 mx-auto">
      <v-input
        input-id="equipment-mobile-content"
        label="Valeur du matériel mobile"
        error-message="La valeur du matériel mobile doit être inférieure ou égale à 1 000 000 €"
        mask="currency"
        module-name="contract"
        getter-name="get"
        setter-name="updateSubscription"
        :getter-function="getMobilContent"
        :input-validation="validateMobileContent"
        path="risk.equipment.mobileContent"
        placeholder="10 000"
      />
    </div>
  </section>
</template>
<script>
import { get } from 'lodash-es';
import { validateMobileContent } from '@/utils/validators';

import Input2 from '@/components/common/input/Input2.vue';

export default {
  components: {
    'v-input': Input2,
  },
  methods: {
    validateMobileContent,
    getMobilContent(contract) {
      return get(contract, 'risk.equipment.mobileContent', null);
    },
  },
};
</script>
